module.exports = __webpack_public_path__ + "img/theme14.1c023154.png";